<template>
    <div class="zioedge-wrapper">
      <div class="section-box">
        <div>
          <h1 class="main-text">ZioEdge</h1>
          <div class="info-wrapper info-text">
            <p class="ds-flex center-center">지오엣지(ZioEdge)는 <span class="bold">엣지 디바이스를 활용한</span><span class="bold blue">AI 개인 · 소규모 관제 시스템</span> 입니다.</p>
            <p class="ds-flex center-center">엣지 디바이스란 '인공지능 디바이스가 내장된 지능형 카메라' 입니다.</p>
          </div>
          <img class="main-img" src="@/assets/product/social/zioedge/edge2.png">
          <img class="main-img" src="@/assets/product/social/zioedge/SaaS.png">
          <img class="main-img" src="@/assets/product/social/zioedge/robot.png">
        </div>
      </div>
      <div class="section-box">
        <div>
          <div class="blue-title-box">
            <p>응용분야</p>
          </div>
          <div class="product-img-box ds-flex center-between">
            <div>
              <img src="@/assets/product/social/zioedge/trespassing.png">
            </div>
            <div>
              <img src="@/assets/product/social/zioedge/approach.png">
            </div>
            <div>
              <img src="@/assets/product/social/zioedge/disappear.png">
            </div>
            <div>
              <img src="@/assets/product/social/zioedge/safe.png">
            </div>
            <div>
              <img src="@/assets/product/social/zioedge/mask.png">
            </div>
            <div>
              <img src="@/assets/product/social/zioedge/fall.png">
            </div>
          </div>     
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'Zioedge',
  components: {
    
  },
  data: () => ({
  }),
  methods: {
    movePage(name) {
      this.$router.push({name: name});
    }
  },
  mounted() {
  },
  created() {
  }
}
</script>

<style scoped>
.zioedge-wrapper {
  color: #191E2C;
  border-top: 1.5px solid #00ACEB;
}

.section-box {
  padding: 80px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.section-box:nth-child(2n) {
  background-color: #F2F6FB;
}

.section-box > div {
  width: 1240px;
}

.section-box p {
  color: #505050;
  font-size: 16px;
  font-weight: 500;
}

.section-box .info-text p {
  font-size: 18px;
}

.info-wrapper {
  padding: 40px 0 80px 0;
}

.section-box .bold {
  font-weight: bold;
  color: #000;
  padding-left: 5px;
}

.section-box .blue {
  color: #00ACEB;
}

.title-box {
  padding-bottom: 40px;
}

.title-box h3 {
  font-size: 22px;
  font-weight: 800;
  text-align: left;
  padding-left: 10px;
}

.mini-blue-box {
  width: 8px;
  height: 8px;
  background-color: #00ACEB;
}

.main-text {
  font-size: 45px;
  color: #5484C4;
  font-weight: 800;
}

.blue-wrapper {
  height: 150px;
  align-content: space-between;
}

.blue-box {
  width: 590px;
  height: 60px;  
  background-color: #5484C4;
  border-radius: 60px;
  color: #fff;
  font-size: 18px;
  font-weight: 500;
}

.main-img {
  margin-bottom: 40px;
}

.main-img:last-child {
  margin-bottom: 0;
}

.blue-title-box {
  padding: 13px 31px 14px 32px;
  border-radius: 24px;
  height: 48px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  width: 261px;
  background-color: #5484C4;
}

.blue-title-box > p {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}

.product-img-box {
  height: 298px;
  display: flex;
  align-content: space-between;
}

.product-img-box > div {
  width: 33%;
  display: flex;
}

@media screen and (max-width: 1240px) {
  .section-box {
    padding: 40px 0;
  }

  .section-box > div {
    width: 768px;
    margin: auto;
  }

  .title-box h3 {
    font-size: 18px;
  }

  .mini-blue-box {
    width: 4px;
    height: 4px;
    position: absolute;
    top: 5px;
    left: 2px;
  }

  .title-box {
    position: relative;
    padding-bottom: 20px;
  }

  .main-text {
    font-size: 30px;
  }

  img {
    width: 430px;
  }

  .blue-wrapper {
    height: 100px;
  }

  .blue-box {
    width: 375px;
    height: 40px;
    font-size: 13px;
  }
}

@media screen and (max-width: 768px) {
  .zioedge-wrapper {
    border-top: none;
  }

  .section-box > div {
    padding: 0 40px;
  }

  .section-box:first-child {
    padding-top: 10px;
  }
  
  .info-wrapper {
    padding: 30px 0;
  }

  img {
    width: 335px;
    height: 286px;
  }

  .blue-box {
    width: 100%;
  }

  .blue-wrapper {
    height: 220px;
  }
}

@media screen and (max-width: 480px) {
  .main-text {
    font-size: 30px;
  }

  .info-wrapper {
    padding: 25px 0 30px 0;  
  }

  img {
    width: 100%;
    height: 100%;
  }

  .title-box h3 {
    font-size: 20px;
  }

  .mini-blue-box {
    width: 6px;
    height: 6px;
    top: 0;
  }

  .blue-wrapper {
    min-width: 360px;
    height: 205px;
  }

  .blue-box {
    font-size: 13px;
  }

  .section-box > div {
    padding: 0 60px;
    min-width: 360px;
  }

  .product-img-box {
    height: 100%;
  }

  .product-img-box > div {
    width: 100%;
    margin-bottom: 20px;
  }

  .info-wrapper {
    padding: 30px 0 40px 0;
  }

  .section-box .info-text p {
    font-size: 12px;
    width: 350px;
  }
}
</style>
